// dependencies
import React from "react";
import { View, StyleSheet } from "react-native";
import { useIntl } from "react-intl";

// components
import { IconAngleLeft } from "@cloudspire/legacy-svg-icon-library";
import Text from "@cloudspire/legacy-resources/src/components/Text";

// theming
import theming from "@cloudspire/legacy-resources/src/constants/theming";

// libraries
import { emToPx } from "@cloudspire/legacy-resources/src/libraries";

const { useTheme } = theming;

type PropsType = {};

const styles = StyleSheet.create({
  carouselLeftNavigation: {
    marginLeft: emToPx(1),
    cursor: "pointer",
  } as any,
  icon: {
    zIndex: 1,
    color: "#ffffff",
    fontSize: emToPx(1.875),
  },
  iconShadow: {
    position: "absolute",
    fontSize: emToPx(1.875),
    transform: [{ translateX: 1, translateY: 1 }],
  },
});

const hitSlop = {
  top: 16,
  bottom: 16,
  right: 16,
  left: 16,
};

const CarouselLeftNavigation: React.FunctionComponent<PropsType> = () => {
  const theme = useTheme();

  const intl = useIntl();

  return (
    <View
      style={styles.carouselLeftNavigation}
      hitSlop={hitSlop}
      accessibilityLabel={intl.formatMessage({
        defaultMessage: "Image précédante",
      })}
    >
      <Text style={styles.icon}>
        <IconAngleLeft />
      </Text>
      <Text
        style={[
          styles.iconShadow,
          {
            color: theme.PRIMARY_COLOR_TEXT,
          },
        ]}
      >
        <IconAngleLeft />
      </Text>
    </View>
  );
};

export default CarouselLeftNavigation;
